/**
 * image-protection.js
 *
 * Deters casual saving/downloading of front-end images by blocking the common
 * UI affordances: right-click context menu, image drag-out, and mobile
 * long-press "Save image". This is a deterrent only — it cannot stop a
 * determined user (dev tools, view-source, screenshots and the direct CDN URL
 * all remain available). Loaded site-wide from layout/theme.liquid.
 */
(() => {
  /**
   * @param {EventTarget|null} target
   * @returns {boolean} true if the event originated on (or inside) an image-like element.
   */
  function isImageTarget(target) {
    if (!(target instanceof Element)) return false;
    return !!target.closest('img, picture, svg, [style*="background-image"]');
  }

  // Block the right-click context menu when it's opened over an image.
  document.addEventListener('contextmenu', (event) => {
    if (isImageTarget(event.target)) event.preventDefault();
  });

  // Block dragging an image out of the page (drag-to-desktop saving).
  document.addEventListener('dragstart', (event) => {
    if (isImageTarget(event.target)) event.preventDefault();
  });

  // Inject CSS to disable the iOS/Android long-press "Save Image" callout and
  // native image dragging, without affecting layout.
  const style = document.createElement('style');
  style.textContent = `
    img, picture {
      -webkit-touch-callout: none;
      -webkit-user-drag: none;
      user-select: none;
      -webkit-user-select: none;
    }
  `;
  document.head.appendChild(style);
})();
